<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Services
	import { format } from '../../../../services/i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	//Helpers
	import { real_id } from '../../../../helpers/interface_helpers';
	//Stores
		//Types
	import type { SettingRequest } from '../../../../types/requests/settings/setting';
	//Design system components
	import { Button, Checkbox, Radio, toast } from '@Shelly/shelly-design-system';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getContext, onDestroy } from 'svelte';
	import type { Writable } from 'svelte/store';
	import type { SidepanelStickyBottomProps } from 'src/components/Sidepanel/sidepanel-types';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const lockTypeOptions = ['none', 'sett', 'full'],
		i18nLockTypeOptions = [
			$format('option_none', { default: 'None' }),
			$format('option_sett', { default: 'No settings' }), //TODO add translations
			$format('option_full', { default: 'Full' }),
		];

	let id = real_id(device.id),
		settings = $settingsStore,
		disableGestures = $settingsStore?.ui?.disable_gestures_when_locked,
		cacheDisableGestures = disableGestures,
		lockType = $settingsStore?.ui?.lock_type,
		cacheLockType = lockType,
		loading = false;
	/**
	 * id: 5
	 * method: "ui.setconfig"
	 * params: {config: {lock_type: "full", disable_gestures_when_locked: true}}
	 * config: {lock_type: "full", disable_gestures_when_locked: true}
	 * disable_gestures_when_locked: true
	 * lock_type: "full"
	 */

	const stickyBottomAction =
		getContext<Writable<SidepanelStickyBottomProps | null>>('stickyBottomAction');

	const changeLockType = (type) => {
		lockType = lockTypeOptions[type];
	};

	const sendRequest = async () => {
		if (cacheDisableGestures === disableGestures && cacheLockType === lockType) {
			return;
		}
		loading = true;
		const params = {
			id: device.channel,
			config: {
				lock_type: lockType,
				disable_gestures_when_locked: disableGestures,
			},
		};

		const res: SettingRequest = await gen2Request(device, `ui.SetConfig`, params);
		const response = await onSettingsResponse(res, device);
		if (response) {
			settings.ui = {
				...settings.ui,
				...params.config,
			};
			devices_settings.update_devices_settings(id, settings);

			cacheDisableGestures = disableGestures;
			cacheLockType = lockType;
		} else {
			disableGestures = cacheDisableGestures;
			lockType = cacheLockType;
		}
		loading = false;
	};

	$: if (stickyBottomAction) {
		if ($showNewLayout) {
			stickyBottomAction.set({ onClick: sendRequest, loading, disabled: loading });
		} else {
			stickyBottomAction.set(null);
		}
	}

	onDestroy(() => {
		stickyBottomAction?.set(null);
	});
</script>

{#each lockTypeOptions as option, index}
	<Radio
		size="m"
		selected={lockType}
		value={option}
		on:click={() => changeLockType(index)}
		id="radio-39t3x56">{i18nLockTypeOptions[index]}</Radio
	>
{/each}
<Checkbox
	checked={disableGestures}
	size="m"
	class="mt-s"
	value={disableGestures}
	on:click={() => (disableGestures = !disableGestures)}
	id="checkbox-ipr0qei"
	>{$format('disable_gestures', {
		default: 'Disable gestures on locked display.',
	})}</Checkbox
>

{#if !$showNewLayout}
	<Button class="mt-s" {loading} size="m" width="full" on:click={sendRequest}
		>{$format('button_save')}</Button
	>
{/if}
